import editQualities from "./EditQualities";

export const moralityModsFor = (item, character, attachmentDefs = []) => {
    const score = parseInt(character?.Morality?.Score);
    if (isNaN(score)) return [];
    return (item.Attachments || []).flatMap((att) => {
        const rule = attachmentDefs.find((a) => a.Key === att.Key)?.MoralityMods || att.MoralityMods;
        if (!rule) return [];
        const min = parseInt(rule.Min);
        const max = parseInt(rule.Max);
        if (!isNaN(min) && score < min) return [];
        if (!isNaN(max) && score > max) return [];
        return rule.Mods || [];
    });
};

export const clearMoralityMods = (item) => {
    if (!item.AppliedMoralityMods?.length) return item;
    const cleared = editQualities(item, item.AppliedMoralityMods, true);
    delete cleared.AppliedMoralityMods;
    return cleared;
};

export const syncMoralityMods = (item, character, attachmentDefs) => {
    const desired = moralityModsFor(item, character, attachmentDefs);
    if (JSON.stringify(desired) === JSON.stringify(item.AppliedMoralityMods || [])) return item;
    let synced = clearMoralityMods(item);
    if (desired.length) {
        synced = editQualities(synced, desired, false);
        synced.AppliedMoralityMods = desired;
    }
    return synced;
};
